/**
 * Breadcrumb helpers for position paths (`PathEntry[]` runs root → parent,
 * without the node itself). Lists show the last two members and put the full
 * path in a tooltip (contract §7).
 */
export type NamedEntry = { name: string };

export function pathLabel(path: NamedEntry[], leaf?: string | null): string {
  const names = path.map((p) => p.name);
  if (leaf) names.push(leaf);
  return names.join(" / ");
}

/** `{ short: "Mlin 1 / Motor", full: "Bankom / Obrenovac / … / Motor" }`; `keep` = trailing members kept in `short`. */
export function shortPathLabel(path: NamedEntry[], leaf?: string | null, keep = 2): { short: string; full: string } {
  const names = path.map((p) => p.name);
  if (leaf) names.push(leaf);
  const full = names.join(" / ");
  if (names.length <= keep) return { short: full, full };
  return { short: `… / ${names.slice(-keep).join(" / ")}`, full };
}
